import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type QueryParams = {
  content_type: string
  fields?: Record<string, string>
  limit?: number
  order?: string
  skip?: number
  include?: number
}

export function buildQuery(params: QueryParams): string {
  const queryParts: string[] = []

  queryParts.push(`content_type=${encodeURIComponent(params.content_type)}`)

  if (params.fields) {
    Object.entries(params.fields).forEach(([key, value]) => {
      queryParts.push(
        `fields.${encodeURIComponent(key)}[match]=${encodeURIComponent(value)}`,
      )
    })
  }

  if (params.limit !== undefined) {
    queryParts.push(`limit=${params.limit}`)
  }

  if (params.order) {
    queryParts.push(`order=${encodeURIComponent(params.order)}`)
  }

  if (params.skip !== undefined) {
    queryParts.push(`skip=${params.skip}`)
  }

  params.include
    ? queryParts.push(`include=${params.include}`)
    : queryParts.push(`include=0`)

  return queryParts.join('&')
}
